<!-- <nb-form-field style="margin: 10px 0;"> -->
  <div class="form-field">
  <label>{{item.translation_key_label||item.label| translation|translationFromString | transformText :item?.text_transform_label}}<span *ngIf="item.required">*</span></label>

  <p-select
  [options]="options"
  [(ngModel)]="selectedValue"
  [required]="item.required"
  (onChange)="updateSelect()"
  [disabled]="checkDisable()"
  optionLabel="label"
  optionValue="value"
  fluid
  appendTo="body"
  [placeholder]="item.translation_key_label || item.label | translation | translationFromString | transformText : item?.text_transform_label"
>


  <ng-template let-option #optionTemplate>
    {{ option?.translation_key_label || option?.label | translation | translationFromString | transformText : option?.text_transform_label }}
  </ng-template>

  <ng-template #selectedItem let-selectedOption>
    {{ selectedOption?.translation_key_label || selectedOption?.label | translation | translationFromString | transformText : selectedOption?.text_transform_label }}
  </ng-template>

</p-select>
</div>
<!--    <span nbSuffix *ngIf="item.helpText||item.translation_key_help_text" pTooltip="{{item.translation_key_help_text||item.helpText| translation|translationFromString | transformText :item?.text_transform_help_text}}"> <i class="fas fa-question-circle"></i> </span>
 </nb-form-field> 
<ng-template *ngFor="let option of options" #options>
  <nb-option [value]="option.value" *ngIf="!option.is_group">{{option.translation_key_label||option.label| translation|translationFromString | transformText :option?.text_transform_label}}</nb-option>
  <nb-optgroup [label]="option.label" *ngIf="option.is_group">
    <nb-option *ngFor="let sub_option of option.options" [value]="sub_option.value">{{sub_option.translation_key_label||sub_option.label| translation|translationFromString | transformText :sub_option?.text_transform_label}}</nb-option>
  </nb-optgroup>
</ng-template>-->
